import { render, staticRenderFns } from "./AddToLoyaltyGroup.vue?vue&type=template&id=c931acc0&scoped=true"
import script from "./AddToLoyaltyGroup.vue?vue&type=script&lang=js"
export * from "./AddToLoyaltyGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c931acc0",
  null
  
)

export default component.exports